import { Observable } from 'rxjs';
import { AppFilter } from 'app/models/app-filter.model';
import { AppService } from 'app/services/app.service';

export abstract class AbDispositivoZeladoria extends AppService {
  abstract validarSerial(serialNumber: string): Observable<any>;
  abstract salvar(dispositivo: any): Observable<any>;
  abstract buscarPorId(id: number): Observable<any>;
  abstract listar(filter: AppFilter): Observable<any>;
  abstract editar(id: number, dispositivo: any): Observable<any>;
  abstract deletar(id: number): Observable<any>;
  abstract buscarStatus(id: number): Observable<any>;
  abstract buscarDashboard(id: number, filter: AppFilter): Observable<any>;
  abstract buscarHistorico(id: number, tipo: string, filter: AppFilter): Observable<any>;
  abstract getFeatureFlag(): Observable<any>;
  abstract listarDispositivosAtivos(): Observable<any>;
}
